import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from '@angular/core';
import { RenderedService } from '../../rendered.service';
import { UndoService } from '@scaffold/services/undo.service';
import { HTMLModalComponent } from '@scaffold/dialogs/htmlmodal/htmlmodal.component';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import cloneDeep from 'lodash/cloneDeep';
import {
  ScaffoldDialogService,
  ScaffoldDialogRef,
} from '@app/framework/dialog/scaffold-dialog.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
    selector: 'scaffold-editor',
    templateUrl: './scaffold-editor.component.html',
    styleUrls: [
        '../../rendered.component.scss',
        './scaffold-editor.component.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ScaffoldEditorComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  public destroy$: Subject<boolean> = new Subject<boolean>();
  editorcontent = [];
  editorExtendedHelp = '<p>Test</p>';
  @Output() change = new EventEmitter<any>();
  editorDetails: any = {};
  // @Input('info')
  set info(v) {
    this._info = v;
    this.editorDetails = {};
    this.editorDetails.id = this._info.id;
    this.editorDetails.title = this._info.title;
    this.editorDetails.comments = {};
    this.editorDetails.info = this._info;
  }
  get info() {
    return this._info;
  }
  undoService: UndoService;
  dialogRef: ScaffoldDialogRef;
  debounce;
  debounce_time = 500;
  editorPreview = false;
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    public dialog: ScaffoldDialogService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    console.log(this.item);
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe(trigger => {
        this.cdr.detectChanges();
      });
    this.editorDetails.name = this.item.name;
    this.editorDetails.comments = this.item._comments;
    this.undoService = new UndoService();
    if (this.value) {
      if (
        this.value.length < 1 &&
        this.item.first_default &&
        this.item.templates &&
        this.item.templates[0]
      )
        this.editDirty(this.item.templates[0].content);
      this.editorcontent = this.value;
    } else {
      if (
        this.item.first_default &&
        this.item.templates &&
        this.item.templates[0]
      )
        this.editDirty(this.item.templates[0].content);
    }
    this.undoService.setup(this.item, 'value');

    // TODO - resetSubsription
    // this.resetSubsription = this.itemsService.registerReset().subscribe(r => {
    //     if (r == 'reset') {
    //         this.item.value = cloneDeep(this.originalItems);
    //     } else if (r = 'saved') {
    //         this.originalItems = cloneDeep(this.item.value);
    //     }
    //     //this.cdr.detectChanges();
    // });
  }

  setDebounce() {
    if (this.debounce) {
      clearTimeout(this.debounce);
    }
    this.debounce = setTimeout(() => {
      this.renderedService.triggerUpdate();
    }, this.debounce_time);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  editDirty(value) {
    console.log(value);
    setTimeout(() => {
      this.change.emit({ value: value });
      if (this.editorPreview) this.setDebounce();
    });
  }

  openHelp(content): void {
    console.log(content);
    let settings: any = {
      context: {
        data: {
          content: content,
        },
      },
    };
    this.dialogRef = this.dialog.open(HTMLModalComponent, settings);
  }

  update() {
    if (JSON.stringify(this.value) != JSON.stringify(this.editorcontent)) {
      let content = [];
      if (this.value) content = cloneDeep(this.value);
      this.editorcontent = content;
    }
  }

  cloneDeep(i) {
    return cloneDeep(i);
  }
}
